export default __webpack_public_path__ + "static/media/classicV2-mobile.54a22e58.jpg";